import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { RevealDirective } from '@ledgerly/common/browser';

import { PostMeta } from '../content/post.model';
import { POSTS } from '../generated/index';
import { PostCardComponent } from '../post-card/post-card.component';
import { currentLocale } from '../site';

/**
 * The landing page's reading list.
 *
 * Three cards, the same ones the blog index uses. It was a compact list of
 * every post, which stopped making sense once the blog started filling up:
 * twenty titles between the price and the questions is an archive dropped
 * into the middle of an argument.
 *
 * It renders nothing when the reader's language has no posts. An empty
 * section on the home page is worse than no section, and a German reader
 * should not be shown English titles to fill it.
 *
 * Only the metadata index is read here, never a post body, so the landing
 * page carries a few hundred bytes per post and none of the HTML.
 */
@Component({
  selector: 'app-learn-section',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PostCardComponent, RevealDirective, RouterLink],
  templateUrl: './learn-section.component.html',
})
export class LearnSectionComponent {
  /**
   * A slice, not an archive. Three cards fill one row on a wide screen and
   * stack cleanly below it, and anyone who wants the rest has the link
   * underneath them.
   */
  static readonly LIMIT = 3;

  private readonly lang = currentLocale();

  protected readonly posts: PostMeta[] = POSTS.filter(
    (post) => post.lang === this.lang
  ).slice(0, LearnSectionComponent.LIMIT);
}
